// node-modules
import PubSub from 'pubsub-js';

// constants
import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';

// assets
import './preloader.scss';

export const PRELOADER_END = 'PRELOADER:END';

export function preloader() {
  const element = document.querySelector('[data-role="preloader"]');
  if (element) {
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    const logo = element.querySelector('[data-role="preloader-logo"]');
    logo.classList.add(SELECTORS.active);
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        element.classList.add(SELECTORS.active);
      }, 1500);
      setTimeout(() => {
        element.classList.add(SELECTORS.hidden);
        PubSub.publish(PRELOADER_END);
      }, 2500);
    });
  } else {
    DOCUMENT_ELEMENT.classList.add('no-preloader');
  }
}
